<template>
    <div class="col-md-4 col-sm-4 col-xs-12 content-colm new-content-colm">
        <div class="card text-center cus-card">
            <div class="card-body">
                <div class="product-img">
                    <router-link :to="{ name: 'single_module', params: { id: data.ModuleID } }">
                        <img :src="`${$server_url}images/Modules/${data.ModuleSmallImage}`" alt="" class=" img-fluid img-responsive">
                    </router-link>
                </div>
                <p class="card-text">Module {{ data.ModuleNumber }}</p>
                <router-link :to="{ name: 'single_module', params: { id: data.ModuleID } }" class="card_btn">{{ data.ModuleName
                }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModuleBoxVue',
    props: {
        // Define the prop name and type
        ModuleData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            data: {}
        }
    },
    watch: {
        ModuleData: {
            immediate: true, // Execute the handler immediately on mount
            handler(newData) {
                this.data = newData;
            }
        }
    }
}
</script>